import {
  useQuery,
  useMutation,
  useQueryClient
} from '@tanstack/react-query'

import { jointScenarioQueryKeys } from '../queryKeys'
import { resourcefulJointScenarioRequest } from '../requests'

export function useJointCashflowEventsQuery({
  jointScenarioId,
  initialData,
  queryKey,
  additionalInvalidationKeys = []
}) {
  const queryClient = useQueryClient()
  // jointCashflowEvent: We should contain a list of scenario resources
  // and reference jointCashflowEvents from there
  const jointCashflowEventRequests = resourcefulJointScenarioRequest(
    jointScenarioId, 'joint_cashflow_events'
  )

  const jointCashflowEventsQuery = useQuery({
    queryFn: jointCashflowEventRequests.index,
    queryKey,
    initialData
  })

  const invalidateQueries = async () => {
    queryClient.invalidateQueries({ queryKey: [jointScenarioQueryKeys.jointCashflowEvents] })
    await queryClient.invalidateQueries({ queryKey: [jointScenarioQueryKeys.forecast] })
    for (const key of additionalInvalidationKeys) {
      await queryClient.invalidateQueries({ queryKey: [key] })
    }
  }

  const createJointCashflowEventMutation = useMutation({
    mutationFn: jointCashflowEventRequests.create,
    onSuccess: () => {
      invalidateQueries()
    },
  })
  const updateJointCashflowEventMutation = useMutation({
    mutationFn: jointCashflowEventRequests.update,
    onSuccess: () => {
      invalidateQueries()
    },
  })
  const deleteJointCashflowEventMutation = useMutation({
    mutationFn: jointCashflowEventRequests.delete,
    onSuccess: () => {
      invalidateQueries()
    },
  })


  const isFetching = jointCashflowEventsQuery.isFetching

  const isAnyLoading = jointCashflowEventsQuery.isFetching ||
    createJointCashflowEventMutation.isLoading

  return {
    data: jointCashflowEventsQuery.data,
    actions: {
      create: createJointCashflowEventMutation.mutateAsync,
      update: updateJointCashflowEventMutation.mutateAsync,
      delete: deleteJointCashflowEventMutation.mutateAsync,
    },
    status: jointCashflowEventsQuery.status,

    /* Boolean flags indicating various states of status */
    isFetching: isFetching,
    isAnyLoading: isAnyLoading
  }
}
